export class ExpectedApiError extends Error {
  readonly reportToSentry = false;

  constructor(message: string) {
    super(message);
    this.name = 'ExpectedApiError';
  }
}

export class ApiNetworkError extends Error {
  readonly endpoint: string;
  readonly method: string;

  constructor(method: string, endpoint: string) {
    super(`Network request failed: ${method} ${endpoint}`);
    this.name = 'ApiNetworkError';
    this.method = method;
    this.endpoint = endpoint;
  }
}

export class ApiResponseError extends Error {
  readonly endpoint: string;
  readonly method: string;
  readonly status: number;

  constructor(method: string, endpoint: string, status: number, detail: unknown) {
    super(`API request failed: ${method} ${endpoint} (${status}): ${JSON.stringify(detail)}`);
    this.name = 'ApiResponseError';
    this.method = method;
    this.endpoint = endpoint;
    this.status = status;
  }
}

export type SentryErrorOptions = {
  ignoreNetworkErrors?: boolean;
};

export function shouldReportToSentry(error: unknown, options: SentryErrorOptions = {}): boolean {
  if (options.ignoreNetworkErrors && error instanceof ApiNetworkError) return false;

  return !(error instanceof ExpectedApiError) &&
    !(
      typeof error === 'object' &&
      error !== null &&
      'reportToSentry' in error &&
      error.reportToSentry === false
    );
}

export function getSentryErrorTags(error: unknown): Record<string, string> {
  if (error instanceof ApiNetworkError) {
    return { errorKind: 'network', endpoint: error.endpoint, method: error.method };
  }
  if (error instanceof ApiResponseError) {
    return {
      errorKind: 'response',
      endpoint: error.endpoint,
      method: error.method,
      status: String(error.status),
    };
  }
  return { errorKind: 'application' };
}
